import useGoToNavigation from '../../util/useGotoNavigation';
import {useTranslation} from 'react-i18next';
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";

export const PasswordReset2 = () => {
    const {state} = useLocation()
    const {goToNavigation} = useGoToNavigation();
    const {t} = useTranslation();

    const [email, setEmail] = useState<string>("")

    useEffect(() => {
        if (state && state.email) {
            setEmail(state.email)
        }
    }, [state]);

    return (
        <>
            <div className="login_content">
                <div className="login_box">
                    <img src={process.env.PUBLIC_URL + "/assets/images/login_logo.png"} alt=""/>
                    <div className="login_text">{t('pwReset2-resetpw-label')}</div>
                    <div className="login_msgbox">
                        <p>
                            {email + t('pwReset2-resetpw-desc1')}<br/>
                            {t('pwReset2-resetpw-desc2')}<br/><br/>
                            {t('pwReset2-resetpw-desc3')}<br/>
                            {t('pwReset2-resetpw-desc4')}<br/>
                            {t('pwReset2-resetpw-desc5')}
                        </p>
                    </div>
                    <button className="btn btn-info btn-lg btn_login"
                            onClick={() => goToNavigation('login', "", false)}>{t('pwReset2-btn-label')}</button>
                </div>
            </div>
        </>
    );
}